module.exports = __webpack_public_path__ + "img/landing-screen-3.40ad4dfb.jpg";